export default __webpack_public_path__ + "static/media/certificate4.2733dd91.jpg";